<template>
  <div ref="balanceTab">
    <div class="tw-flex tw-items-center tw-gap-[10px] tw-mt-[10px]">
      <div class="tw-text-[15px]">
        <span class="tw-text-forTitle">
          {{ dataLang["clients_register_text_62"] }} &nbsp;
        </span>
        <span
          class="tw-font-[600]"
          :style="{
            color:
              dataForTab?.clients__balance >= 0 ? '#23b14d' : 'rgb(255, 36, 0)',
          }"
        >
          {{ dataForTab?.clients__balance.replace(".", ",") }}
        </span>
      </div>

      <button
        class="tw-app-btn-primary-outline"
        @click="$modal.show('AddBalanceModal')"
      >
        <img
          :src="require(`@/assets/icons/add.svg`)"
          width="13.5"
          height="13.5"
          class="tw-my-[-5px]"
        />
        {{ dataLang["clients_register_text_63"] }}
      </button>

      <button
        class="tw-app-btn-primary-outline"
        @click="$modal.show('WriteOffClientsModal')"
      >
        <img
          :src="require(`@/assets/icons/minus-dark.svg`)"
          width="13.5"
          height="13.5"
          class="tw-my-[-5px]"
        />
        {{ dataLang["clients_register_text_64"] }}
      </button>

      <button
        class="tw-app-btn-primary-outline"
        @click="$modal.show('BackBalanceClientsModal')"
      >
        <img
          :src="require(`@/assets/icons/round-arrow.svg`)"
          width="13.5"
          height="13.5"
          class="tw-my-[-5px]"
        />
        {{ dataLang["clients_register_text_65"] }}
      </button>

      <button class="tw-app-btn-primary-outline" @click="loadExel">
        <img
          :src="require(`@/assets/icons/excel-dark.svg`)"
          width="13.5"
          height="13.5"
          class="tw-my-[-5px]"
        />
        {{ dataLang["clients_register_text_67"] }}
      </button>
    </div>

    <div class="tw-flex tw-justify-between tw-mt-[10px]">
      <div class="tw-flex">
        <button @click="loadData(1)" class="tw-app-btn-primary-outline">
          {{ dataLang["register_btn_filter_on"] }}
        </button>
        <button
          @click="resetFilter"
          class="tw-app-btn-light !tw-text-[#0056AF]"
        >
          {{ dataLang["register_btn_filter_off"] }}
        </button>
      </div>
      <TwBasePagination
        :page-count="computedAllPage"
        :pagination-params="{
          ...activePagePagination,
          limit: limitPaginationValue,
        }"
        :showLimitInput="false"
        @updateLimitValue="updateLimitValue"
        :page-range="10"
        :margin-pages="0"
        :click-handler="loadData"
      >
      </TwBasePagination>
    </div>

    <div class="tw-relative tw-mt-[10px]">
      <BaseLoader v-if="localLoading"></BaseLoader>
      <ve-table
        class="rest-style-table"
        style="width: 100%"
        :columns="columns"
        :table-data="dataTable"
        :border-x="true"
        :border-y="true"
        :sort-option="sortOption"
        ref="serviceTable"
        row-key-field-name="client_balance__id"
        :checkbox-option="{
          hideSelectAll: true,
          selectedRowChange: selectedRowChange,
          selectedAllChange: selectedAllChange,
        }"
        v-if="!localLoading"
        :clickHighlight="false"
        :rowStyleOption="{
          hoverHighlight: true,
        }"
        :cellSelectionOption="{ enable: false }"
      />
    </div>

    <AddBalanceModal :optionalParams="{ id: tabInfo }"></AddBalanceModal>
    <WriteOffClientsModal
      :optionalParams="{ id: tabInfo }"
    ></WriteOffClientsModal>
    <BackBalanceClientsModal
      :optionalParams="{ id: tabInfo }"
    ></BackBalanceClientsModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import ObjectsService from "@/api/ObjectsService";
import EventBus from "@/event-bus.js";
import GeneralService from "@/api/GeneralService";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import AddBalanceModal from "./AddBalanceModal.vue";
import WriteOffClientsModal from "./WriteOffClientsModal.vue";
import BackBalanceClientsModal from "./BackBalanceClientsModal.vue";
export default {
  components: {
    VeTable,
    AddBalanceModal,
    WriteOffClientsModal,
    BackBalanceClientsModal,
    // AddNewNoteModalInNotesTab,
    // ZapchastiVehicleModalSingle,
    // SimpleModal
  },

  props: {
    modalInfo: {
      type: Object,
    },

    currentOpenedId: {
      type: Number,
    },
  },
  data() {
    return {
      isDataLoading: false,
      limitPaginationValue: 14,
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      tabInfo: this.modalInfo,
      computedAllPage: 1,
      activePagePagination: {},

      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      dataForTab: {},
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
    };
  },
  methods: {
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      callback(true, nameTab, oldTab, newTab, flagIsClose);
    },
    async loadExel() {
      let dataFrom = await GeneralService.toSpecExcel(
        `/clients/${this.modalInfo.id}/table/balance/xlsx`
      );

      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    acceptDelete() {
      if (this.activeSelectRowsMultiple) {
        EventBus.$emit("openModal", {
          data: null,
          nameForAction: "acceptDeleteNote",
          mode: "create",
        });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    closeDeleteModal() {
      EventBus.$emit("closeModal", {
        data: null,
        nameForAction: "acceptDeleteNote",
        mode: "create",
      });
      this.activeSelectRowsMultiple = [];
    },
    deleteRow() {
      this.$emit("loadingModal", true);
      ObjectsService.delete(
        "notes",
        this.currentOpenedId,
        this.activeSelectRowsMultiple
      )
        .then((data) => {
          this.loadData();
          this.activeSelectRowsMultiple = [];
          this.closeDeleteModal();
        })
        .catch((err) => {
          this.$emit("loadingModal", false);

          this.activeSelectRowsMultiple = [];
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },
    openModalSingle(nameModal) {
      EventBus.$emit("openModal", {
        data: null,
        nameForAction: nameModal,
        mode: "create",
      });
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    loadData(page = 1) {
      if (this.isDataLoading) return;
      this.localLoading = true;
      this.urlToQuaries.params.page = page;
      this.urlToQuaries.params.limit = this.limitPaginationValue;
      GeneralService.get(this.urlToQuaries.url, {
        params: this.urlToQuaries.params,
      }).then((data) => {
        this.localLoading = false;
        this.activePagePagination = data.data.data;
        this.computedAllPage = data.data.data.total / data.data.data.limit;
        this.dataTable = data.data.data.rows;
        this.activeSelectRowsMultiple = null;
        this.isDataLoading = true;
      });
    },
    resetFilter() {
      // this.selectsData
      this.filter = [];
      this.loadData();
      this.$refs.serviceTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
    },
    sortChange(params) {
      this.dataTable.sort((a, b) => {
        if (params.vehicle_services__created_at) {
          if (params.vehicle_services__created_at === "asc") {
            return (
              a.vehicle_services__created_at - b.vehicle_services__created_at
            );
          } else if (params.vehicle_services__created_at === "desc") {
            return (
              b.vehicle_services__created_at - a.vehicle_services__created_at
            );
          } else {
            return 0;
          }
        }
        if (params.vehicle_services__odometr) {
          if (params.vehicle_services__odometr === "asc") {
            return a.vehicle_services__odometr - b.vehicle_services__odometr;
          } else if (params.vehicle_services__odometr === "desc") {
            return b.vehicle_services__odometr - a.vehicle_services__odometr;
          } else {
            return 0;
          }
        }
        if (params.vehicle_services__text) {
          if (params.vehicle_services__text === "asc") {
            return a.vehicle_services__text - b.vehicle_services__text;
          } else if (params.vehicle_services__text === "desc") {
            return b.vehicle_services__text - a.vehicle_services__text;
          } else {
            return 0;
          }
        }
        if (params.vehicle_services__price) {
          if (params.vehicle_services__price === "asc") {
            return a.vehicle_services__price - b.vehicle_services__price;
          } else if (params.vehicle_services__price === "desc") {
            return b.vehicle_services__price - a.vehicle_services__price;
          } else {
            return 0;
          }
        }
        if (params.employees__name) {
          if (params.employees__name === "asc") {
            return a.employees__name - b.employees__name;
          } else if (params.employees__name === "desc") {
            return b.employees__name - a.employees__name;
          } else {
            return 0;
          }
        }
      });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.mod && { mod: data.mod }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    loadGlobal() {
      if (this.isDataLoading) return;
      GeneralService.get(
        `/clients/${this.tabInfo.id}?joins=statistics,verifications,documents`
      )
        .then((data) => {
          this.dataForTab = data.data.data.rows[0];
          this.isDataLoading = true;
        })
        .catch((e) => {});
    },
  },
  mounted() {
    this.loadGlobal();
    this.loadData();
    dayjs.extend(utc);
    EventBus.$off("updateContentData"); //убьем старый слушатель событие перед тем как объявить новый, иначе будут дубли запросов при переключении между вкладками
    EventBus.$on("updateContentData", () => {
      this.loadGlobal();
      this.loadData();
    });
  },
  // created() {
  //   this.loadGlobal();
  // },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    checkboxOption() {
      return {
        hideSelectAll: true,
        selectedRowChange: this.selectedRowChange,
        selectedAllChange: this.selectedAllChange,
        selectedRowKeys: [],
      };
    },
    urlToQuaries() {
      return {
        url: `/clients/${this.tabInfo.id}/table/balance`,
        params: {
          // limit: 14,
          // page: 1,
          ...(this.filter.length && { where: JSON.stringify(this.filter) }),
        },
      };
    },
    columns() {
      return [
        {
          field: "client_balance__created_at",
          key: "1",
          title: this.dataLang["clients_register_text_68"],
          align: "left",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like", mod: "datetimeUTC" }}
                  inputName={"client_balance__created_at"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.client_balance__created_at
                  ? dayjs(row.client_balance__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },

        {
          field: "client_balance__amount",
          key: "25",
          title: this.dataLang["clients_register_text_69"],
          align: "left",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"client_balance__amount"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span
                class={
                  row.client_balance__direction !== "+"
                    ? `text-danger`
                    : `text-confirmation`
                }
              >
                {row.client_balance__direction !== "+"
                  ? `-${row.client_balance__amount.split(".").join(",")}`
                  : `+${row.client_balance__amount.split(".").join(",")}`}
              </span>
            );
          },
        },
        {
          field: "client_balance__direction",
          key: "25",
          title: this.dataLang["clients_register_text_666"],
          align: "left",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },

          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span
                class={
                  row.client_balance__direction !== "+"
                    ? `text-danger`
                    : `text-confirmation`
                }
              >
                {row.client_balance__direction !== "+" ? `Расход` : `Приход`}
              </span>
            );
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 20px"}></div>
              </div>
            );
          },
        },
        {
          field: "client_balance__comment",
          key: "31",
          title: this.dataLang["clients_register_text_70"],
          align: "left",
          width: "40%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"client_balance__comment"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "client_balance__creator",
          key: "34",
          title: this.dataLang["clients_register_text_71"],
          align: "left",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"client_balance__comment"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "client_balance__fin_id",
          key: "23",
          title: this.dataLang["clients_register_text_72"],
          align: "left",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"client_balance__fin_id"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
